<template>
  <a-modal
    v-model="isShow"
    title="发起提现"
    @ok="handleOkFunc"
    :confirmLoading="confirmLoading"
    @cancel="handleCancel"
  >
    <a-form-model ref="infoFormModel" :model="saveObject" :label-col="{span: 6}" :wrapper-col="{span: 15}" :rules="rules">
      <a-form-model-item label="收款账户">
        <span>{{ accountInfo.cardName ? accountInfo.cardName + ' - ' : '' }}{{ accountInfo.cardId }}</span>
      </a-form-model-item>
      <a-form-model-item label="可用余额">
        <span style="color: #5485f8; font-weight: bold;">
          {{ accountInfo.avlBalance ? parseFloat(accountInfo.avlBalance).toFixed(2) : '0.00' }} 元
        </span>
      </a-form-model-item>
      <a-form-model-item label="提现金额" prop="amount">
        <a-input v-model="saveObject.amount" placeholder="请输入提现金额（元）" />
      </a-form-model-item>
      <a-form-model-item label="商户订单号" prop="mchOrderNo">
        <a-input v-model="saveObject.mchOrderNo" placeholder="不填则自动生成" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { doUserWithdraw } from '@/api/manage'

export default {
  props: {
    callbackFunc: { type: Function }
  },
  data () {
    const validateAmount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入提现金额'))
        return
      }
      const amount = parseFloat(value)
      if (isNaN(amount) || amount <= 0) {
        callback(new Error('请输入有效的提现金额'))
        return
      }
      const avlBalance = parseFloat(this.accountInfo.avlBalance || 0)
      if (amount > avlBalance) {
        callback(new Error('提现金额不能大于可用余额'))
        return
      }
      callback()
    }
    return {
      confirmLoading: false,
      isShow: false,
      saveObject: { amount: '', mchOrderNo: '' },
      accountInfo: {},
      rules: {
        amount: [
          { required: true, validator: validateAmount, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    show (accountInfo) {
      this.accountInfo = accountInfo || {}
      this.saveObject = { amount: '', mchOrderNo: '', adapayAccountId: this.accountInfo.id }
      this.confirmLoading = false
      if (this.$refs.infoFormModel !== undefined) {
        this.$refs.infoFormModel.resetFields()
      }
      this.isShow = true
    },
    handleCancel () {
      this.isShow = false
    },
    handleOkFunc () {
      const that = this
      this.$refs.infoFormModel.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          const param = {
            adapayAccountId: this.accountInfo.id,
            amount: this.saveObject.amount
          }
          if (this.saveObject.mchOrderNo) {
            param.mchOrderNo = this.saveObject.mchOrderNo
          }
          doUserWithdraw(param).then(res => {
            that.$message.success('提现申请提交成功')
            that.isShow = false
            that.callbackFunc()
          }).catch(() => {
            that.confirmLoading = false
          })
        }
      })
    }
  }
}
</script>